/* eslint-disable complexity */
/* eslint-disable max-lines-per-function */
import { Termin } from '@/domain/termine/shared/types/Termin';
import {
  faBarsSort,
  faCalendarStar,
  faCircleInfo,
  faClock,
  faArrowsRepeat,
} from '@fortawesome/pro-regular-svg-icons';
import {
  getWiederholungStringFromTerminWiederholung,
  TerminWiederholung,
} from '@/domain/termine/shared/types/TerminWiederholung';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import { TerminImage } from '@/domain/termine/components/TerminImage';
import { TerminInfoRow } from '@/domain/termine/features/Calendar/shared/TerminInfo/TerminInfoRow';
import { useCalendarContext } from '@/domain/termine/features/Calendar/shared/CalendarContext';

export function TerminInfo({ termin }: { termin: Termin }) {
  const { t } = useTranslation();
  const { kalender } = useCalendarContext();
  const start = dayjs(termin.beginn).locale('de');
  const end = termin.ende ? dayjs(termin.ende).locale('de') : null;

  const matchingKalender = kalender?.find(
    (k) => k.id === termin.idTerminkalender,
  );
  return (
    <div className="flex flex-col gap-5">
      <div className="grid grid-cols-[auto,1fr] gap-x-3 items-center">
        <TerminImage
          bildUrl={termin.image?.url}
          bildName={termin.image?.name}
          markierung={termin.markierung}
          variant="detail"
        />
        <div
          className="font-semibold text-xl line-clamp-2 min-w-0"
          title={termin.titel}>
          {termin.titel}
        </div>
      </div>
      <div className="grid grid-cols-[1fr] gap-3 items-center text-neutrals-N900">
        {termin.beginn && (
          <TerminInfoRow icon={faClock}>
            {start.format('dddd, D. MMMM')} · {start.format('HH:mm')}
            {end && ` – ${end.format('HH:mm')}`}
          </TerminInfoRow>
        )}

        {termin.wiederholung &&
          termin.wiederholung !== TerminWiederholung.OHNE && (
            <TerminInfoRow icon={faArrowsRepeat}>
              {`${t('domain.termine.repeat', {
                wiederholung: termin.wiederholung,
              })} ${getWiederholungStringFromTerminWiederholung(
                termin.wiederholung,
              ).toLowerCase()}`}{' '}
              {termin.wiederholungBis &&
                `bis ${dayjs(termin.wiederholungBis).format('DD.MM.YYYY')}`}
            </TerminInfoRow>
          )}

        {termin.beschreibung && (
          <TerminInfoRow icon={faBarsSort}>
            <p className="line-clamp-3 leading-5" title={termin.beschreibung}>
              {termin.beschreibung}
            </p>
          </TerminInfoRow>
        )}

        {termin.specials && (
          <TerminInfoRow icon={faCircleInfo}>
            <p className="line-clamp-3 leading-5" title={termin.specials}>
              {termin.specials}
            </p>
          </TerminInfoRow>
        )}

        {matchingKalender && (
          <TerminInfoRow icon={faCalendarStar}>
            {matchingKalender.name}
          </TerminInfoRow>
        )}
      </div>
    </div>
  );
}
